export default {
  Timer: 'Timer',
  TimerStart: 'Start Timer',
  TimerPause: 'Pause',
  TimerHour: 'Hour',
  TimerMinute: 'Minute',
  TimerSecond: 'Second',
  TimerPaused: 'Paused',
  TimerResume: 'Resume',
  TimerReset: 'Reset',
  TimerEnded: "Time's up",
  TimerSetPrompt: 'Please set a timer duration',
  TimerRunning: 'Timer is running',
  TimerMinuteLabel: 'Minute',
};
